import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  tech: {
    title: 'Core Technologies',
    dec: ['The core R&D team for 4DKanKan Pro is composed of experts in AI and computer vision from China and Germany.',
      'Utilizing AI space reconstruction algorithms and big data technologies for 3D spaces, 4DKanKan Pro',
      'can instantly capture point-cloud data of the spaces and generate accurate 3D spaces.'
    ],
    icon: ['Space localization', 'Space reconstruction', 'Space display'],
    location: {
      title: 'Space Localization',
      dec: 'Acquire accurate information from real-life space, including shooting point location and corresponding point cloud data, etc.'
    },
    modeling: {
      title: 'Space Reconstruction',
      dec: 'According to the position of the camera and the corresponding point-cloud data, the space layout plan and 3D structure will be generated autonomously.'
    },
    exhibition: {
      title: 'Space Display',
      dec: 'No plug-ins are required for immersive virtual strolling across 720° on mobile phones, tablets, PCs and with VR glasses.'
    }
  },
  cases: {
    title: 'Industrial Applications',
    dec: [
      '4DKanKan has reconstructed 3D digital scenes from fire-fighting, criminal investigations and museums, as well as contributed to industries',
      'such as real estate, hotels and accommodations, e-commerce, and catering to create brand-new experiences for consumers.'
    ],
    space: {
      title: 'Every Space is Worth Recording',
      sub: 'Spaces 4DKanKan recorded so far',
      nums: [
        {
          text: 'Museum',
          count: 16893
        },
        {
          text: 'Real estate',
          count: 32689
        },
        {
          text: 'E-commerce',
          count: 65682
        },
        {
          text: 'Catering',
          count: 42737
        },
        {
          text: 'Home',
          count: 61368
        }
      ]
    }
  },
  booking: {
    name: '4DKanKan Pro',
    dec: 'Professional and accurate modeling that reconstructs space with efficiency',
    price: '100元定金预售',
    btn: 'Buy it on Alibaba',
    sub: 'Exclusive 10 GB cloud capacity for 5 years for the early birds.'
  },
  items: [
    {url: 'https://www.4dkankan.com/showProPC.html?m=t-0Q99SHE',
      image: baseUrl + 'images/phone_11.png',
      icon: baseUrl + 'images/phone_icon_11.png',
      text: 'Coffee Canteen' },
    {url: 'https://www.4dkankan.com/showPC.html?m=x2kIkoCB',
      image: baseUrl + 'images/phone_7.jpg',
      icon: baseUrl + 'images/phone_icon_7.png',
      text: 'Marriott Hotel' },
    {url: 'https://admin.4dmuseum.cn/showPC.html?m=241&bigScene&novr',
      image: baseUrl + 'images/phone_2.jpg',
      icon: baseUrl + 'images/phone_icon_2.png',
      text: 'Guangdong Museum' },
    {url: 'http://www.4dkankan.com/showPC.html?m=laaVIiT7',
      image: baseUrl + 'images/phone_3.jpg',
      icon: baseUrl + 'images/phone_icon_3.png',
      text: 'Haihunhou Archaeological Exhibition' },
    {url: 'http://www.4dkankan.com/showPC.html?m=OOM185Kf',
      image: baseUrl + 'images/phone_4.jpg',
      icon: baseUrl + 'images/phone_icon_4.png',
      text: 'Huafa Real Estate' },
    {url: 'http://www.4dkankan.com/showPC.html?m=djryzBtW',
      image: baseUrl + 'images/phone_5.jpg',
      icon: baseUrl + 'images/phone_icon_5.png',
      text: 'OPPEIN Kitchen Cabinets' },
    {url: 'http://www.4dkankan.com/showPC.html?m=ImlLYDW8',
      image: baseUrl + 'images/phone_6.jpg',
      icon: baseUrl + 'images/phone_icon_6.png',
      text: 'Ronshine Real Estate' },
    {url: 'https://www.4dkankan.com/showPC.html?m=X99yIvTq',
      image: baseUrl + 'images/phone_1.jpg',
      icon: baseUrl + 'images/phone_icon_1.png',
      text: 'German Ceramic Museum' },
    {url: 'https://www.4dkankan.com/showPC.html?m=iTz0LxLs',
      image: baseUrl + 'images/phone_8.jpg',
      icon: baseUrl + 'images/phone_icon_8.png',
      text: 'Vanke Real Estate' },
    {url: 'https://www.4dkankan.com/showPC.html?m=0mVvxHHT',
      image: baseUrl + 'images/phone_9.jpg',
      icon: baseUrl + 'images/phone_icon_9.png',
      text: 'Weixing Real Estate' },
    {url: 'https://admin.4dmuseum.cn/showApp.html?m=240&bigScene&novr',
      image: baseUrl + 'images/phone_10.jpg',
      icon: baseUrl + 'images/phone_icon_10.png',
      text: 'Baoji Bronze Museum' }

  ],
  reports: {
    name: 'Media Coverage',
    items: [
      {
        icon: baseUrl + 'images/item_icon_7.png',
        cover: baseUrl + 'images/item_cover_7.png',
        time: 'May 17, 2019',
        title: '4DAGE Launches 4DKanKan Pro — New Generation 3D Space Camera',
        url: 'https://proapi.jingjiribao.cn/detail.html?id=177829'
      },
      {
        icon: baseUrl + 'images/item_icon_8.png',
        cover: baseUrl + 'images/item_cover_8.png',
        time: 'May 31, 2019',
        title: '4DAGE Launches 4DKanKan Pro — New Generation 3D Space Camera Reducing 3D Reconstruction Costs',
        url: 'https://mp.weixin.qq.com/s/ui--KOL1hcmgob7935clBg'
      },

      {
        icon: baseUrl + 'images/item_icon_2.png',
        cover: baseUrl + 'images/item_cover_2.png',
        time: 'October 29, 2018',
        title: 'Former Minister of Science and Technology Wan Gang Speaks Highly of 4DKanKan in His Inspection of 4DAGE Booth',
        url: 'http://bj.news.163.com/18/1029/14/DV9U6QN8043897TC.html'
      },
      {
        icon: baseUrl + 'images/item_icon_4.png',
        cover: baseUrl + 'images/item_cover_4.png',
        time: 'November 19, 2018',
        title: '4DAGE Launches Mobile Terminal 3D Reconstruction Technology, Fueling the Growth of AI Industry',
        url: 'http://smart.huanqiu.com/viewpoint/2018-11/13585013.html'
      }
    ]
  },
  sequenceArr: [
    {
      name: 'Autonomous & Accurate Modeling, Automatic Distance Measurement',
      img: '1en',
      runAnimation: true
    },
    {
      name: '720° Immersive Roaming with 8K Picture Quality',
      img: 7,
      runAnimation: true
    },
    {
      name: '10 Minutes to Start, Easy to Operate',
      img: '8en',
      runAnimation: true
    },
    {
      name: 'Autonomous Space Modeling in 10 Minutes, Efficient and Fast',
      sub: '(Approximately 100㎡)',
      img: 9,
      runAnimation: true
    },
    {
      name: 'Multifunctional Editing Tool, Let Space Tell the Story',
      img: '10en',
      runAnimation: true
    }
  ],
  services: {
    down: {
      txt: 'Download the " 4DKanKan Pro " APP to start shooting',
      sub: 'Please search for“4DKanKan Pro” in the App Store or scan the QR code to install the App.'
    }
  },
  loginAside: {
    xieyi: 'Read to the bottom and click "Confirm" to take effect. ',
    cancel: 'Cancel',
    comfirm: 'Confirm',
    cluse: 'I have read 4DKanKan User Agreement.',
    login: 'Log in',
    submit: 'Submit',
    scansub: 'Scan the QR-Code to log in with the 4DKanKan App',
    loginsub1: 'Don’t have an account? ',
    loginsub2: ' Sign Up',
    resigter1: 'Already have an account, ',
    resigter2: ' log in now.',
    phone: {
      placeholder: 'Phone number'
    },
    password: {
      placeholder: 'Enter password'
    },
    code: {
      txt: 'Request verification code',
      placeholder: 'Verification code'
    },
    userName: {
      placeholder: 'User name'
    },
    newpass: {
      placeholder: 'Password (minimum 8 letters and digits)'
    },
    comfirmpass: {
      placeholder: 'Enter password again'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/language/en/home.js